export default "__VITE_ASSET__$Jqaftr9__"